export default {
  email: function (email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
  password: function (password) {
    const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{4,})/;
    return re.test(password);
  },
  cardNumber: function (card) {
    const visa = new RegExp("^4[0-9]{12}(?:[0-9]{3})?$");
    const amex = new RegExp("^3[47][0-9]{13}$");
    const mastercard = new RegExp("^5[1-5][0-9]{14}$");
    const discover = new RegExp("^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$");
    return visa.test(card) || amex.test(card) || mastercard.test(card) || discover.test(card);
  },
};
